import { Row } from 'components/wrappers/grid/FlexWrapper';
import { Button } from 'ui-kit/components/buttons/Button';
import { Select } from 'ui-kit/components/Select/Select';
import { addUserModalStore } from 'stores/modals/model';
import { Input } from 'ui-kit/components/inputs/Input';
import { Modal } from 'ui-kit/components/Modal';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { type FC } from 'types/react';

import { Container } from './styles';

export const AddUserModal: FC = () => {
    const { closeModal, modal } = addUserModalStore;
    const { t } = useTranslation();

    const [_, { title }] = useUnit(modal);

    const handleClose = () => {
        closeModal();
    };

    return (
        <Modal
            customFooter={
                <Row justifyEnd gap="16px">
                    <Button variant="secondary">Cancel</Button>
                    <Button variant="primary">Invite user</Button>
                </Row>
            }
            onClose={handleClose}
            title={title}
            visible
        >
            <Container>
                <Input placeholder="Enter first user name" title="First name" />
                <Input placeholder="Enter last user name" title="Last name" />
                <Input placeholder="example@gmail.com" title="Email" />
                <div>{t('Role')}</div>
                <Select
                    options={[
                        { label: 'Admin', value: 'admin' },
                        { label: 'User', value: 'user' }
                    ]}
                />
            </Container>
        </Modal>
    );
};
